// MD2 PRO
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Card from '@mui/material/Card';
import ProductMovementsContract from 'layouts/production/Components/AaroComponents/ProductMovementsContract';
import OrderMovementsContract from 'layouts/production/Components/AaroComponents/OrderMovementsContract';
import CustomerMovements from 'layouts/production/Components/AaroComponents/CustomerMovements';
function AaroContractLeftArea({ production, relatedID, aaroQueries, setValue }) {
    // Ensure production object exists to prevent errors
    if (!production) {
        return null;
    }

    return (
        <>
            <Card sx={{ mb: 2 }}>
                <MDBox p={3}>
                    <MDBox mb={3}>
                        <MDTypography variant="h6" fontWeight="medium">
                            Sipariş Hareketleri
                        </MDTypography>
                    </MDBox>
                    <OrderMovementsContract aaroQueries={aaroQueries} />
                </MDBox>
            </Card>
            {/* Müşteri Hareketleri */}
            <Card sx={{ mb: 2 }}>
                <MDBox p={3}>
                    <MDBox mb={3}>
                        <MDTypography variant="h6" fontWeight="medium">
                            Tahsilatlar
                        </MDTypography>
                    </MDBox>
                    <CustomerMovements aaroQueries={aaroQueries} />
                </MDBox>
            </Card>

            {/* Ürün Hareketleri */}
            <Card sx={{ mb: 2 }}>
                <MDBox p={3}>
                    <MDBox mb={3}>
                        <MDTypography variant="h6" fontWeight="medium">
                            Ürün Hareketleri
                        </MDTypography>
                    </MDBox>
                    <ProductMovementsContract aaroQueries={aaroQueries} />
                </MDBox>
            </Card>
        </>
    );
}

export default AaroContractLeftArea;
